export default {
    brands:          { method: 'get',    url: 'brands' },
    brandCreate:     { method: 'post',   url: 'brands' },
    brandUpdate:     { method: 'put',    url: 'brands/{id}' },
    brandDelete:     { method: 'delete', url: 'brands/{id}' },
}